"use client";

import { ArrowUpIcon } from "@heroicons/react/24/solid";
import React, { useEffect, useState } from "react";

export default function ScrollToTopButton() {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 300) {
        setShowBackToTop(true);
      } else {
        setShowBackToTop(false);
      }
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return showBackToTop ? (
    <button
      onClick={scrollToTop}
      className="fixed bottom-[80px] right-4 md:bottom-[80px] md:right-8 bg-white hover:bg-[#188F46] text-[#188F46] hover:text-white rounded-full px-4 py-2 md:px-6 md:py-3 shadow-lg transition-all duration-300 z-[9999] flex items-center gap-2 border-2 border-[#188F46] group"
      aria-label="กลับสู่ด้านบน"
      name="กลับสู่ด้านบน"
    >
      <ArrowUpIcon className="w-4 h-4 md:w-5 md:h-5 transform group-hover:-translate-y-1 transition-transform duration-300" />
      <span className="font-bold text-base">กลับสู่ด้านบน</span>
    </button>
  ) : (
    <></>
  );
}
